import { Controller } from 'stimulus';

// Fills the job count on each Find work tab (app/views/mobile/work/index)
// from the Jobs screen's view-count endpoint (JobsController#view_counts), so
// the phone shows the same numbers as the Jobs screen's pills. Fetched after
// the page shows; a view whose count failed (null) or is missing stays blank.
export default class extends Controller {
  connect() {
    const url = this.data.get('url');
    if (!url) return;

    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, redirect: 'manual' })
      .then((response) => (response.ok ? response.json() : {}))
      .then((counts) => {
        this.element.querySelectorAll('[data-view-count]').forEach((badge) => {
          const count = counts[badge.dataset.viewCount];
          if (typeof count === 'number') badge.textContent = count.toLocaleString();
        });
      })
      .catch(() => {});
  }
}
